"use client";

import type { ReactNode } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Pickers (voice, character, style, color) share this popover. */
export function StudioPopover({
  label,
  trigger,
  children,
  open,
  onOpenChange,
  align,
  triggerClassName,
  contentClassName,
}: {
  label: string;
  trigger: ReactNode;
  children: ReactNode;
  /** Optional controlled open state (close after a pick). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  align?: "start" | "center" | "end";
  triggerClassName?: string;
  contentClassName?: string;
}) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button type="button" aria-label={label} className={triggerClassName}>
          {trigger}
        </button>
      </PopoverTrigger>
      <PopoverContent
        data-studio-overlay=""
        align={align}
        className={`studio-overlay-popover${contentClassName ? ` ${contentClassName}` : ""}`}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
